module.exports = __webpack_public_path__ + "img/option-website.8a31cc47.png";